import React from "react";
import { useNavigate } from "react-router";
import { Box, Typography } from "./styles";
import Icon from "../Icon";
import { Props } from "../Icon/IconView";
import { useCookies } from "react-cookie";
import moment from "moment";
import dayjs from "dayjs";
export interface MenuBaseProps {
  icon: Props["name"];
  title: string;
  path: string;
  action?: () => void;
}

export interface MenuProps extends MenuBaseProps {
  isSelected: boolean;
}

const Menu = ({ icon, title, path, isSelected, action }: MenuProps) => {
  const [cookies, setCookie, removeCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();
  const className = isSelected ? "selected" : "";
  const navigate = useNavigate();
  const onClick = (event: React.MouseEvent) => {
    if (action) {
      event.preventDefault();
      action();
    } else {
      setCookie("menu", path, { path: "/", expires });

      setCookie("status", "InReview", { path: "/", expires });
      setCookie("startDate", dayjs().subtract(1, "month").toDate(), {
        path: "/",
        expires,
      });
      setCookie("endDate", dayjs().toDate(), { path: "/", expires });
      setCookie("tSort", "asc", { path: "/", expires });

      setCookie("mStatus", "InReview", { path: "/", expires });
      setCookie("mStartDate", dayjs().subtract(1, "month").toDate(), {
        path: "/",
        expires,
      });
      setCookie("mEndDate", dayjs().toDate(), { path: "/", expires });
      setCookie("mSort", "asc", { path: "/", expires });

      navigate(path);

      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }
  };

  return (
    <Box className={className} onClick={onClick}>
      <Icon name={icon} size={24} />
      <Typography className={className}>
        <b>
          <u>{title[0]}</u>
        </b>
        {title.slice(1)}
      </Typography>
    </Box>
  );
};

export default Menu;
